export default "__VITE_ASSET__630c7063__"